import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import {lastValueFrom, Subject} from 'rxjs';
import {ApiCallService} from "../../helpers/api-call.service";
import {WindowRefService} from "../../helpers/windowref.service";
import {MessageService} from "primeng/api";
import {NavigationService} from "../../helpers/navigation.service";
import { DataServiceService } from 'src/app/helpers/data.service';

@Component({
    selector: 'app-tiktok-coupon-step2',
    templateUrl: './tiktok-coupon-step2.component.html',
    styleUrls: ['./tiktok-coupon-step2.component.scss'],
    standalone: false
})
export class TiktokCouponStep2Component implements OnInit, OnDestroy {
  componentDestroyed: Subject<boolean> = new Subject();
  currentYear: number = new Date().getFullYear();
  loading: boolean = false;
  geo: string = 'Global';
  openTabIndex:any = undefined;
  metricData:any = {
    link: {
      amount: '2,850',
      text: 'Accounts Linked',
    },
    redeemed: {
      amount: '1,583',
      text: 'Coupons Redeemed',
    },
    saved: {
      amount: '$633,200',
      text: 'Saved',
    }
  };
  page = 'tiktok';
  constructor(private router: Router, private apiCallService: ApiCallService, private winRef: WindowRefService,
              private messageService: MessageService, private navigationService: NavigationService, public data:DataServiceService) {
                this.data.setHeaderMenuSelection('14');
               }

  ngOnInit(): void {
    this.navigationService.canNavigateToStep3TikTok = false;
    this.winRef.reportGtagEventNew('pageViewStep2');
    document.body.scrollTop = 0;
  }

  ngOnDestroy(): void {
    this.componentDestroyed.next(true);
    this.componentDestroyed.complete();
  }

  goToEligibleLink(channel:string) {
    this.data.goToEligibleLink(channel);
   }
   
  changeSelectedTabIndex(e:any) {
    if (e) {
      this.openTabIndex =e.index;
    }
  }

  async RedeemCoupon() {
    const info = sessionStorage.getItem('tiktokInfo');
    const sessionToken = sessionStorage.getItem('tiktokToken');
    const passedList = sessionStorage.getItem("tiktokPassedList")
    if (info && sessionToken && passedList) {
      const infoJson = JSON.parse(info);
      const refreshToken = infoJson.refresh_token;
      const customerIdList = JSON.parse(passedList);
      if (refreshToken && customerIdList && customerIdList.length) {
        this.loading = true;
        const params = {
          refresh_token: refreshToken,
          customer_id_list: customerIdList,
          session_token: sessionToken,
          geo: this.geo,
          utm_source: infoJson.utm_source,
          utm_medium: infoJson.utm_medium,
          page: this.page
        };
        const accept$ = this.apiCallService.accept(params, 'tiktok');
        const response = await lastValueFrom(accept$);
        this.loading = false;
        if (response.result == 'success'){
          sessionStorage.removeItem("tiktokInfo");
          sessionStorage.removeItem("tiktokToken");
          sessionStorage.removeItem("tiktokPassedList")
          this.navigationService.canNavigateToStep3TikTok = true;
          this.router.navigate(['/tt/step3']);
        } else {
          const detail = response.error || response.errInfo || "TikTok is having trouble connecting your account. Please try again later or contact couponer@adcore.com";
          this.messageService.add({
            key: 'msgTemplate',
            severity: 'error',
            summary: 'We apologize for the inconvenience.',
            detail: detail,
            closable: true,
            sticky: true
          })
        }
      }
    }
  }

  got_it(): void {
    this.navigationService.canNavigateToStep3TikTok = true;
    this.router.navigate(['/tt/step3']);
  }
}
